module.exports = __webpack_public_path__ + "static/2-0965fa740c39247bd49a95497e4fcb2b.jpg";